import React from 'react';
import { Tooltip } from '@material-ui/core';
import WorkBreakdownProgressBar from '../WorkBreakdownProgressBar';
import { Flex, Margin, Padding } from '../base/layout-components';
import Text from '../base/Text';
import BoldedValue from '../BoldedValue';
import { ScaledTooltipWrapper } from './TooltipWrapper';
import { resetTooltipStyle } from './helpers';
import Icon from 'components/base/Icon';

const WorkBreakdownTooltip = ({
  title,
  headLine,
  configurations,
  scale = 0.75
}) => {
  return (
    <ScaledTooltipWrapper title={title} scale={scale}>
      <Padding padding='medium'>
        {headLine && (
          <BoldedValue
            value={{ size: 'x-x-large', text: headLine.value }}
            description={{ size: 'small', text: headLine.description }}
            mb='small'
          />
        )}
        <WorkBreakdownProgressBar
          configurations={configurations}
          textFirstOnItems
          height='6rem'
        />
      </Padding>
    </ScaledTooltipWrapper>
  );
};

export const WorkBreakdownPopupTooltip = ({
  title,
  headLine,
  configurations,
  targetBranch,
  scale,
  children,
  disableHoverListener
}) => {
  const validateConfigurations = configurations =>
    !configurations.some(item => isNaN(item.percent));

  const WorkBreakdown = (
    <ScaledTooltipWrapper scale={scale}>
      <Padding padding='medium'>
        <Margin b='medium'>{title}</Margin>
        {headLine && (
          <Flex justify='flex-start' align='center'>
            <Icon name='Pencil' size='normal' />
            <BoldedValue
              value={{ size: 'x-x-large', text: headLine.value }}
              description={{ size: 'x-medium', text: headLine.description }}
              mb='small'
              ml='small'
            />
          </Flex>
        )}
        <WorkBreakdownProgressBar
          configurations={configurations}
          textFirstOnItems
          height='6rem'
        />
        {targetBranch && (
          <Text pt='1rem' size='large'>{`target branch: ${targetBranch}`}</Text>
        )}
      </Padding>
    </ScaledTooltipWrapper>
  );
  return validateConfigurations(configurations) ? (
    <Tooltip
      classes={resetTooltipStyle()}
      title={WorkBreakdown}
      disableHoverListener={disableHoverListener}
    >
      {children}
    </Tooltip>
  ) : null;
};

export default WorkBreakdownTooltip;
